// @ts-nocheck
import { ProductBrandStyles } from "@insite/content-library/Components/ProductBrand";
import { ProductDescriptionStyles } from "@insite/content-library/Components/ProductDescription";
import { ProductImageStyles } from "@insite/content-library/Components/ProductImage";
import { ProductQuantityBreakPricingStyles } from "@insite/content-library/Components/ProductQuantityBreakPricing";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import { CheckboxPresentationProps } from "@insite/mobius/Checkbox";
import { GridContainerProps } from "@insite/mobius/GridContainer/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import { TypographyProps } from "@insite/mobius/Typography";
import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { contentSpacingStyles } from "@store/Themes/common/mixins/spacing";

import { ProductPriceStyles } from "@store/Overrides/Components/ProductPrice";
import { lazyLoadStyles } from "@store/Themes/common/mixins/lazyload";

import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { gridGapStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

/* Store Custom Code - Start */
import HeartLine from "@store/Library/Components/Toolkit/Icons/Heart/HeartLine";
import { IconProps } from "@store/MobiusOverrides/Icon/Icon";
import { TextFieldProps } from "@store/MobiusOverrides/TextField/TextField";
import { CompareCheckboxStyles } from "@store/Library/Components/Common/CompareCheckbox";
import { ProductAddToCartButtonProps } from "@store/Overrides/Components/ProductAddToCartButton";
import { ProductAddToListLinkStyles } from "@store/Overrides/Components/ProductAddToListLink";
/* Store Custom Code - End */

interface ProductNumbersProps {
    container?: GridContainerProps;
    labelText?: TypographyProps;
    valueText?: TypographyProps;
}

export const productNumbers: ProductNumbersProps = {
    container: {
        gap: 0,
        css: css`
            ${gridGapStyles([], [".5em"])}
            ${({ theme }) => `
                line-height: ${theme.design.typography.lineHeight.smaller};
                font-size: ${theme.design.typography.size.smaller};
            `}
        `,
    },
    labelText: {
        color: "text.main",
        transform: "uppercase",
        css: css`
            display: flex;
            width: auto;
            margin-right: ${pxToRem(5)};
            white-space: nowrap;
            ${({ theme }) => `
                font-weight: ${theme.design.typography.weight.base};
                font-size: ${theme.design.typography.size.smaller};
            `}
        `,
    },
    valueText: {
        color: "text.dark",
        transform: "uppercase",
        css: css`
            display: flex;
            flex-wrap: wrap;
            width: auto;
            white-space: nowrap;
            ${({ theme }) => `
                font-weight: ${theme.design.typography.weight.bold};
                font-size: ${theme.design.typography.size.smaller};
            `}
        `,
    },
};

interface ProductListProps {
    wrapper?: InjectableCss;
    imageWrapper?: InjectableCss;
}

export const productListProps: ProductListProps = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            height: 100%;
            padding: ${pxToRem(20)};
            border: ${pxToRem(3)} solid ${getColor("common.borderLight")};
            background-color: ${getColor("common.background")};
        `,
    },
    imageWrapper: {
        css: css`
            display: flex;
            justify-content: center;
            width: 100%;
            margin: 0 auto;
            margin-bottom: ${pxToRem(20)};
        `,
    },
};

interface ProductCardImageStyles {
    wrapper?: InjectableCss;
    productImage?: ProductImageStyles;
    compareCheckbox?: CheckboxPresentationProps;
}

export const productCardImageStyles: ProductCardImageStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
        `,
    },
    compareCheckbox: {
        css: css`
            align-self: center;
            padding-top: ${pxToRem(20)};
        `,
    },
    productImage: {
        image: {
            width: "100%",
            css: css`
                ${lazyLoadStyles()}
                img {
                    min-width: 100%;
                }
            `,
        },
    },
};

interface ProductListProductInformationStyles {
    brandStyles?: ProductBrandStyles;
    descriptionStyles?: ProductDescriptionStyles;
    productInformationWrapper?: InjectableCss;
    informationItem?: InjectableCss;
    brandWrapper?: InjectableCss;
}

export const productCardInformationStyles: ProductListProductInformationStyles = {
    descriptionStyles: {
        productDetailLink: {
            css: css`
                width: 100%;
                display: flex;
                align-items: center;

                ${breakpointValues(["0", pxToRem(64)], "min-height")}
            `,
            typographyProps: {
                color: "primary",
                forwardAs: "h2",
                variant: "h4",
            },
        },
    },
    productInformationWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            height: 100%;
            /* Bunzl Custom Code */
            gap: ${({ theme }) => theme.design.layout.spacing.smaller};
        `,
    },

    brandStyles: {
        nameText: {
            css: css`
                margin-bottom: 0;
            `,
        },
        nameLink: {
            typographyProps: {
                css: css`
                    margin-bottom: 0;
                    ${({ theme }) => `
                        font-weight: ${theme.design.typography.weight.base};
                        font-size: ${theme.design.typography.size.tiny};
                    `}
                `,
            },
        },
    },
};
// Store Custom Code - added export
export interface ProductListActionsStyles {
    wrapper?: InjectableCss;
    addToCartButton?: ButtonPresentationProps;
    quantityBreakPricing?: ProductQuantityBreakPricingStyles;
    price?: ProductPriceStyles;
    rightColumn?: InjectableCss;
    leftColumn?: InjectableCss;
    /* Store Custom Code - Start */
    compareAddToListWrapper?: InjectableCss;
    buttonRow?: InjectableCss;
    quantityOrdered?: TextFieldProps;
    productAddToCartButton?: ProductAddToCartButtonProps;
    compareCheckbox?: CompareCheckboxStyles;
    priceSection?: InjectableCss;
    addToListLink?: ProductAddToListLinkStyles;
    addToListIcon?: IconProps;
    addToListWrapper?: InjectableCss;
    /* Store Custom Code - End */
}

export const actionsCardStyles: ProductListActionsStyles = {
    /* Store Custom Code - Start */
    addToListWrapper: {
        css: css`
            display: flex;
            align-items: center;
        `,
    },
    addToListIcon: {
        src: HeartLine,
        css: css`
            color: ${getColor("primary")};
            margin-right: ${pxToRem(5)};
        `,
        size: 18,
    },
    addToListLink: {
        link: {
            mergeCss: true,
            css: css`
                font-weight: ${({ theme }) => theme.design.typography.weight.bold};
                font-size: ${({ theme }) => theme.design.typography.size.smaller};
                margin-left: auto;
            `,
        },
    },
    priceSection: {
        css: css`
            display: flex;
            flex-direction: row;
            align-items: center;
            row-gap: ${({ theme }) => theme.design.layout.spacing.smallest};
            flex-grow: 1;
            flex-wrap: wrap;
            width: 100%;
            justify-content: space-between;
        `,
    },
    compareCheckbox: {
        checkbox: {
            mergeCss: true,
            css: css`
                margin-bottom: 0;

                label {
                    font-weight: ${({ theme }) => theme.design.typography.weight.bold};
                    color: ${getColor("primary")};
                }
            `,
        },
    },
    productAddToCartButton: {
        extendedStyles: {
            css: css`
                width: 100%;
                min-height: ${pxToRem(44)};
            `,
        },
        variantButtonExtendedStyles: {
            css: css`
                width: 100%;
                min-height: ${pxToRem(44)};
            `,
        },
    },
    quantityOrdered: {
        cssOverrides: {
            formField: css`
                margin-right: ${pxToRem(10)};
                width: 4.1rem;
                min-width: 4.1rem;

                /* Store Custom Code - Start */
                label {
                    font-size: ${({ theme }) => theme.design.typography.size.smaller};
                    margin-bottom: 0;
                }

                /* Store Custom Code - End */
            `,
        },
    },
    buttonRow: {
        css: css`
            display: flex;
            align-items: flex-end;
            flex-grow: 1;
        `,
    },
    compareAddToListWrapper: {
        css: css`
            display: flex;
            flex-grow: 1;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            min-height: 36px;
        `,
    },
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            flex-wrap: wrap;
            justify-content: space-between;
            width: 100%;
            row-gap: ${({ theme }) => theme.design.layout.spacing.smallest};
        `,
    },
    /* Store Custom Code - End */
    /* Bunzl Deleted Code */
    addToCartButton: {
        css: css`
            ${({ theme }) => theme.button.primary.css}
            width: 100%;
        `,
        typographyProps: {
            css: css`
                white-space: nowrap;
            `,
        },
    },
    /* Store Custom Code - Start */
    price: {
        wrapper: {
            css: css`
                width: auto;
                height: auto;
                padding: 0;
            `,
        },
        price: {
            priceText: {
                css: css`
                    font-size: ${({ theme }) => theme.design.typography.size.base};
                    font-weight: ${({ theme }) => theme.design.typography.weight.bold};
                    color: ${getColor("text")};
                `,
            },
            errorText: {
                css: css`
                    font-size: ${({ theme }) => theme.design.typography.size.smaller};
                    max-width: ${pxToRem(150)};
                `,
            },
        },
    },
    /* Store Custom Code - End */
    rightColumn: {
        css: css`
            display: flex;
            flex-direction: column;
            flex-grow: 2;

            > * {
                ${contentSpacingStyles(0, 0, pxToRem(10), 0)}
            }
        `,
    },
    leftColumn: {
        css: css`
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            flex-grow: 1;
            min-width: 40%;
            padding-right: ${pxToRem(10)};

            > * {
                ${contentSpacingStyles(0, 0, pxToRem(10), 0)}
                min-height: 2.8em !important;
                margin: auto 0;
            }
        `,
    },
};
